import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { View } from "./view";
import { translate } from "src/common/utilities";


class ViewModelIdGenerator {
    private static currentIndex: number = 0;
    public static getNewId() {
        return ++ViewModelIdGenerator.currentIndex;
    }
}

export abstract class ViewModelMessage {

}

export abstract class ViewModelCreationRequestMessage extends ViewModelMessage {
    abstract create(parentViewModel: ViewModel): ViewModel;
}

export abstract class ViewModel {
    public parentViewModel: ViewModel;

    constructor(parentViewModel: ViewModel) {
        this.RealConstructor(parentViewModel);
    }

    public RealConstructor(parentViewModel) {
        this.parentViewModel = parentViewModel;
        this.viewModelObjectId = ViewModelIdGenerator.getNewId();
        Object.defineProperty(this, 'selfinternaluseonly', {
            set: function (v) { }.bind(this),
            get: function () { return this; }.bind(this),
            configurable: true
        });
    }

    public abstract getTypeId(): string;
    public abstract GetDefaultView(): View<ViewModel>
    public set viewModelObjectId(v: number) { this._viewModelObjectId = v; } public get viewModelObjectId(): number { return this._viewModelObjectId; } private _viewModelObjectId: number;

    public handleMessage(message: ViewModelMessage) {
        if (this.parentViewModel !== null) {
            return this.parentViewModel.handleMessage(message);
        }
        return null;
    }

    public async messageBox(message: string, title: string, type: "success" | "warning" | "danger" | "dark", ...buttons: { title: string, titleLtr: string, className: "danger" | "info" | "success" | "primary" | "secondary" | "warning", resultCode: string, cancelling?: boolean }[]): Promise<string> {
        let promise = new Promise<string>((resolve, reject) => {
            let msg = new ShowMessageBoxMessage();
            msg.title = title;
            msg.message = message;
            msg.type = type;
            msg.resolveFunction = resolve;
            msg.buttons = buttons;
            this.handleMessage(msg);
        });
        return promise;
    }

    public async messageBoxDangerYesNo(message: string, title: string) {
        return this.messageBox(message, title, "danger", { titleLtr: "Yes", title: translate("viewmodel.yes",{}), className: "danger", "resultCode": "yes" }, { titleLtr: "No", title: translate("viewmodel.no",{}), className: "secondary", "resultCode": "no", cancelling: true })
    }

    public async messageBoxWarningYesNo(message: string, title: string) {
        return this.messageBox(message, title, "warning", { titleLtr: "Yes", title: translate("viewmodel.yes",{}), className: "success", "resultCode": "yes" }, { titleLtr: "No", title: translate("viewmodel.no",{}), className: "danger", "resultCode": "no", cancelling: true })
    }

    public async messageBoxSuccessYesNo(message: string, title: string) {
        return this.messageBox(message, title, "success", { titleLtr: "Yes", title: translate("viewmodel.yes",{}), className: "primary", "resultCode": "yes" }, { titleLtr: "No", title: translate("viewmodel.no",{}), className: "secondary", "resultCode": "no", cancelling: true })
    }

    public async messageBoxConfirmSuccess(message: string, title: string) {
        return this.messageBox(message, title, "success", { titleLtr: "OK", title: translate("viewmodel.confirm",{}), className: "success", "resultCode": "ok", cancelling: true })
    }

    public async messageBoxConfirmWarning(message: string, title: string) {
        return this.messageBox(message, title, "warning", { titleLtr: "OK", title: translate("viewmodel.confirm",{}), className: "success", "resultCode": "ok", cancelling: true })
    }
    async requestShowingPopup(popup: IPopup, autohide: boolean = true, additionalInfo: any = null, cancelResult: any = null): Promise<any> {
        let message = new ShowPopupMessage();
        message.popup = popup;
        message.autoHide = autohide;
        message.additionalInfo = additionalInfo;
        message.cancelResult = cancelResult;
        let result = this.handleMessage(message);
        return result;
    }
    async requestRefreshWindow() {
        return this.handleMessage(new RequestRefreshMessage());
    }
    async tryClose(shallConfirm: boolean = true, message: string = 'no', confirmMessage?: string, confirmMessageTitle?: string) {

        let result: string = 'yes';
        if (shallConfirm == true) {
            confirmMessage = confirmMessage ?? translate("viewmodel.closePage",{});
            confirmMessageTitle = confirmMessageTitle ?? translate("viewmodel.exit",{});
            result = await this.messageBoxWarningYesNo(confirmMessage, confirmMessageTitle);
        }
        if (result == 'yes') {
            if (this['closePopup'] != null) {
                this['closePopup'](message);
            } else if (this['close']) {
                this['close']();
            }
        }
    }

}

export class RequestRefreshMessage extends ViewModelMessage {

}

export class ShowPopupMessage extends ViewModelMessage {
    constructor(popup?: IPopup, autohide?: boolean) {
        super()
        this.popup = popup;
        this.autoHide = autohide ?? true;
    }
    public popup: IPopup;
    public autoHide: boolean;
    public additionalInfo: any;
    public cancelResult: any;
}

export class ShowMessageBoxMessage extends ViewModelMessage {
    constructor() {
        super();
        this.direction = "rtl"
    }
    public title: string;
    public message: string;
    public buttons: { titleLtr: string, title: string, className: "danger" | "info" | "success" | "primary" | "secondary" | "warning", resultCode: string, cancelling?: boolean }[];
    public type: "success" | "warning" | "danger" | "dark";
    public direction: "ltr" | "rtl";
    resolveFunction: (str: string) => void;
}
